import React from "react"
import { useState, useEffect } from "react"

import StepComponentPreview from "../StepComponentPreview"
import EditablePriorStepComponent from "../EditablePriorStepComponent"
import { PRODUCTION_STEPS_PRIOR_COMPONENT_NAME, StyledAccordionSummary } from "../Steps"
import { getSupplierItemWithId } from "../../../../../parseManager/suppliers/supplierItems/parseSupplierItemManager"

const PriorSteps = ({
  type,
  isEdition,
  onRowBlur,
  onRowHover,
  index,
  sectionIndex,
  indexComponent,
  hasError,
  step,
  transformationModes,
  isStepComponentHover,
  setFieldValue,
  indexSubComponent,
  subStepComponent,
  steps,
  section,
  recipe,
  fromRecipe,
  stepComponentsIndexesList,
  isReusable,
  priorStepSupplierItem
}) => {
  const handleRowHover = () => {
    if (!onRowHover) return
    onRowHover(PRODUCTION_STEPS_PRIOR_COMPONENT_NAME, index, sectionIndex, indexComponent, indexSubComponent, stepComponentsIndexesList)
  }
  const [fullPriorStepSupplierItem, setFullPriorStepSupplierItem] = useState(priorStepSupplierItem)

  const subStepComponents = !subStepComponent.supplierItem && subStepComponent.priorSteps?.stepComponents.length > 0 ? subStepComponent.priorSteps.stepComponents : [subStepComponent]

  // Retrieve the supplierItem latest info (from the dB)
  useEffect(() => {
    const getSupplierItem = async () => {
      if (priorStepSupplierItem && priorStepSupplierItem.supplierItem) {
        const id = priorStepSupplierItem.supplierItem.objectId || priorStepSupplierItem.supplierItem.id
        const fullSupplierItem = await getSupplierItemWithId(id)
        setFullPriorStepSupplierItem(fullSupplierItem)
      } else {
        setFullPriorStepSupplierItem(priorStepSupplierItem?.supplierItem || null)
      }
    }
    getSupplierItem()
  }, [priorStepSupplierItem])

  return (
    <StyledAccordionSummary
      onMouseEnter={handleRowHover}
      onMouseLeave={onRowBlur}
      componentName={PRODUCTION_STEPS_PRIOR_COMPONENT_NAME}
      isReusable={isReusable}
      usage={"stepComponents"}
    >
      {
        subStepComponents.map((subSubStepComponent, indexSubSubComponent) => (
          isEdition
            ? (
              <EditablePriorStepComponent
                type={type}
                sectionIndex={sectionIndex}
                hasError={hasError}
                stepComponent={subSubStepComponent}
                supplierItem={fullPriorStepSupplierItem ?? subSubStepComponent?.supplierItem}
                indexComponent={indexSubComponent}
                indexStep={index}
                parentStep={step}
                key={indexSubSubComponent}
                indexSubComponent={indexSubSubComponent}
                transformationModes={transformationModes}
                isHover={isStepComponentHover(index, indexSubComponent, stepComponentsIndexesList)}
                setFieldValue={setFieldValue}
                steps={steps}
                section={section}
                recipe={recipe}
                fromRecipe={fromRecipe}
                stepComponentsIndexesList={stepComponentsIndexesList}
              />
            ) : (
              <StepComponentPreview
                key={indexSubComponent + "-" + indexSubSubComponent}
                stepComponent={subSubStepComponent}
                supplierItem={fullPriorStepSupplierItem ?? subSubStepComponent?.supplierItem}
                subComponent
              />)
        ))
      }
    </StyledAccordionSummary>
  )
}

export default PriorSteps
